// Message précis pour les erreurs métier du service PDF (champ `code` de sa
// réponse, cf. pdf/handler.js). `undefined` pour tout autre code : l'appelant
// garde alors son message générique.
const NO_PRINTABLE_CONTENT = 'NO_PRINTABLE_CONTENT';

export const specificPdfErrorMessage = (code) =>
  code === NO_PRINTABLE_CONTENT
    ? 'Aucun contenu à imprimer : le document ne contient que des sections variables ou des éléments non imprimables.'
    : undefined;
